import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import AddNotificationModel from "./AddNotificationModel";
import { indexStore } from "src/store/indexStore";
import NotificationCard, {
  NotificationCardLoading,
} from "../Cards/NotificationCard";
import Iterator from "../utils/Iterator";
import Visibility from "../utils/Visibility";
import { Card, CardContent } from "../ui/card";
import { Bell, Sparkles } from "lucide-react";

function Notifications() {
  const { t } = useTranslation();
  const { fetchNotificationsFunction, notifications, notificationsLoading } =
    indexStore();
  useEffect(() => {
    fetchNotificationsFunction();
  }, [fetchNotificationsFunction]);

  return (
    <div className="flex flex-col gap-6">
      {/* Header Section */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-lg bg-primary/10">
            <Bell className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-foreground">
              {t("dashbord.notifications")}
            </h2>
            <p className="text-sm text-muted-foreground">
              {t("gloabl.manage_notifications") ||
                "Create and manage push notifications for your users"}
            </p>
          </div>
        </div>
        <AddNotificationModel />
      </div>

      {/* Notifications Grid */}
      <div className="flex-1">
        <Visibility visible={!notificationsLoading && notifications.length > 0}>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Sparkles className="w-5 h-5 text-primary" />
                <h3 className="text-lg font-semibold">
                  {t("gloabl.notifications_found") || "Notifications"} (
                  {notifications.length})
                </h3>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              <Iterator
                data={notifications}
                render={(notification) => (
                  <NotificationCard
                    key={notification.id}
                    notification={notification}
                  />
                )}
              />
            </div>
          </div>
        </Visibility>

        <Visibility visible={notificationsLoading}>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            <Iterator
              data={[1, 2, 3, 4, 5, 6]}
              render={(e, i) => <NotificationCardLoading key={i} />}
            />
          </div>
        </Visibility>

        <Visibility visible={!notificationsLoading && notifications.length === 0}>
          <Card>
            <CardContent className="flex flex-col items-center justify-center py-12">
              <Bell className="w-16 h-16 text-muted-foreground mb-4" />
              <h3 className="text-lg font-semibold mb-2">
                {t("gloabl.no_notifications_found") || "No notifications found"}
              </h3>
              <p className="text-sm text-muted-foreground text-center mb-4">
                {t("gloabl.no_notifications_description") ||
                  "Create your first notification to engage with your users"}
              </p>
              <AddNotificationModel />
            </CardContent>
          </Card>
        </Visibility>
      </div>
    </div>
  );
}

export default Notifications;
